import React from "react";
import "../css/GandhiCentre.css";

const GandhiCentre = () => {
  const centerImg = "/images/high.jpg";

  return (
    <section className="gandhi-section">
      <div className="gandhi-container">
        {}
        <div className="gandhi-text-box">
          <p className="gandhi-para">
            A dedicated Mahatma Gandhi(India) Centre for Universal Values in all
            our global campuses serves as an institutional lodestar for the
            values and beliefs of the Mahatma, and its relevance to today's
            world.
          </p>
          <p className="gandhi-para">
            Through the centre, we ensure that our students get valuable
            insights into the teachings of Mahatma Gandhi(India), as well, we
            make an active effort to imbibe these values into our students.
          </p>
        </div>

        {}
        <div className="gandhi-visual-box">
          <div className="gandhi-dashed-frame"></div>
          <div className="gandhi-img-wrapper">
            <img src={centerImg} alt="Students" className="gandhi-main-img" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GandhiCentre;
